export default {
    recordDetails: {
        enableInventory: "Lagerverwaltung aktivieren",
        inventoryDisabled: "Die Lagerverwaltung ist deaktiviert",
        inventoryEnabled: "Lagerverwaltung aktiviert",
        inventorySaved: "Lagerkorrektur gespeichert",
        itemTitle: "Artikeldetails",
        expenseTitle: "Ausgabendetails",
        timeTitle: "Details zum Zeiteintrag",
        information: "Details",
        receipt: "Beleg",
        inventoryHistory: "Lagerhistorie",
        inventoryLoadFailed: "Die Lagerhistorie konnte nicht geladen werden.",
        noInventory: "Noch keine Lagerbewegungen",
        loadFailed: "Die Details konnten nicht geladen werden.",
        deleteConfirm: "Diesen Eintrag löschen?",
        deleted: "Eintrag gelöscht"
    },
    common: {
        appName: 'Swift Invoice',
        back: 'Zurück',
        cancel: 'Abbrechen',
        email: 'E-Mail',
        password: 'Passwort',
        or: 'oder',
        change: 'Ändern',
        delete: 'Löschen',
        save: 'Speichern',
        edit: 'Bearbeiten',
        add: 'Hinzufügen',
        close: 'Schließen',
        date: 'Datum',
        total: 'Gesamt',
        status: 'Status',
        amount: 'Betrag',
        quantity: 'Menge',
        rate: 'Satz',
        tax: 'Steuer',
        discount: 'Rabatt',
        note: 'Notiz',
        notes: 'Notizen',
        noData: 'Keine Daten',
        description: 'Beschreibung',
        client: 'Kunde',
        item: 'Artikel',
        items: 'Artikel',
        type: 'Typ',
        category: 'Kategorie',
        phone: 'Telefon',
        name: 'Name',
        subject: 'Betreff',
        saveAndClose: 'Speichern und Schließen',
        saveAndSendEmail: 'Speichern und E-Mail senden',
        sendEmail: 'E-Mail senden',
        send: 'Senden',
        print: 'Drucken',
        moreActions: 'Weitere Aktionen',
        preparingPdf: 'PDF wird vorbereitet...',
        pdfPreparationFailed: 'PDF konnte nicht vorbereitet werden',
        warning: 'Warnung',
        ok: 'OK',
        uploadSuccess: 'Upload erfolgreich',
        saveSuccess: 'Speichern erfolgreich',
        deleteSuccess: 'Löschen erfolgreich',
        deleteFailed: 'Löschen fehlgeschlagen',
        saveFailed: 'Speichern fehlgeschlagen',
        loadFailed: 'Laden fehlgeschlagen',
        systemError: 'Systemfehler',
        sendSuccess: 'Senden erfolgreich',
        updateSuccess: 'Aktualisierung erfolgreich',
        unsavedChangesMsg: 'Sie haben ungespeicherte Änderungen. Möchten Sie diese speichern oder verwerfen?',
        saveChangesTitle: 'Änderungen speichern?',
        confirmSave: 'Speichern',
        discard: 'Verwerfen',
        validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        deleteFailedMsg: 'Löschen fehlgeschlagen',
        shipping: 'Versand',
        attachment: 'Anhang',
        days: 'Tage',
        excl: '(exkl.)',
        incl: '(inkl.)',
        of: 'von',
        batchActions: 'Stapelaktionen',
        selected: 'ausgewählt',
        select: 'Auswählen',
        batchDeleteConfirm: '{count} ausgewählte Einträge löschen?',
        batchActionSuccess: '{count} Einträge aktualisiert',
        batchActionPartial: '{processed} aktualisiert; {skipped} ohne Änderung',
        batchEmailInvalidRecipients: 'Geben Sie für jedes Dokument einen gültigen Empfänger ein',
        batchEmailSent: '{count} E-Mails gesendet',
        batchEmailPartial: '{sent} gesendet; {failed} fehlgeschlagen',
        emailHtmlNotAllowed: 'E-Mail-Betreff und -Text dürfen kein HTML enthalten.'
    },
    emailVerification: {
        title: 'E-Mail-Adresse bestätigen',
        description: 'Wir haben einen Bestätigungscode an Ihre Anmelde-E-Mail-Adresse gesendet:',
        codePlaceholder: 'Bestätigungscode eingeben',
        enterCode: 'Geben Sie den Code aus der E-Mail ein, um fortzufahren.',
        sent: 'Bestätigungscode gesendet.',
        resent: 'Ein neuer Bestätigungscode wurde gesendet.',
        validFor: 'Der Code ist 10 Minuten gültig.',
        verify: 'Bestätigen',
        resend: 'Erneut senden',
        success: 'E-Mail-Adresse bestätigt. Ihre E-Mail wird jetzt gesendet.',
        failed: 'Der Bestätigungscode ist falsch oder abgelaufen.',
        limitReached: 'Das heutige Sendelimit ist erreicht.',
        remaining: 'Heute noch {count} Sendungen verfügbar',
        contactUs: 'Kontakt'
    },
    login: {
        heroPrefix: 'Intelligente ',
        heroInvoicing: 'Rechnungsstellung',
        heroMiddle: ',',
        heroSimplified: 'Vereinfacht',
        heroSuffix: ' für Sie.',
        subtitle1: 'Erstellen, senden und verwalten Sie Rechnungen mühelos.',
        subtitle2: 'Werden Sie mit Swift Invoice schneller bezahlt.',
        feature1Title: 'Professionelle Rechnungen',
        feature1Text: 'Erstellen Sie in wenigen Minuten schöne Rechnungen',
        feature2Title: 'Echtzeit-Verfolgung',
        feature2Text: 'Verfolgen Sie Zahlungen und Rechnungsstatus',
        feature3Title: 'Sicher & Zuverlässig',
        feature3Text: 'Ihre Daten sind mit Enterprise-Sicherheit geschützt',
        welcomeBack: 'Willkommen zurück',
        signInToContinue: 'Melden Sie sich bei Ihrem Konto an, um fortzufahren',
        enterEmail: 'Geben Sie Ihre E-Mail ein',
        enterPassword: 'Geben Sie Ihr Passwort ein',
        rememberMe: 'Angemeldet bleiben',
        forgotPassword: 'Passwort vergessen?',
        signIn: 'Anmelden',
        signingIn: 'Anmeldung…',
        continueWithGoogle: 'Mit Google fortfahren',
        continueWithApple: 'Mit Apple fortfahren',
        createAccount: 'Konto erstellen',
        startUsing: 'Swift Invoice verwenden',
        companyName: 'Firmenname',
        enterCompanyName: 'Geben Sie Ihren Firmennamen ein',
        alreadyHaveAccount: 'Bereits ein Konto? Anmelden',
        footerRights: '© 2026 Swift Invoice. Alle Rechte vorbehalten.',
        termsOfService: 'Nutzungsbedingungen',
        contactUs: 'Kontakt: goodinvoicego@gmail.com',
        betaDialogBody: 'Unser Team hat die erste Version des Webs abgeschlossen <br> Diese Version ist nur für iPhone-Benutzer verfügbar <br> Wir werden die Web-Funktion so schnell wie möglich verbessern und für alle öffnen <br>',
        ieDialogBody: 'Leider unterstützen wir den IE-Browser aufgrund von Kompatibilitätsproblemen derzeit nicht. Wenn Sie ihn verwenden möchten, laden Sie bitte',
        resetPasswordTitle: 'Passwort zurücksetzen',
        sendResetEmail: 'Reset-E-Mail senden',
        resetEmailSent: 'E-Mail zum Zurücksetzen des Passworts gesendet. Bitte überprüfen Sie Ihren Posteingang.',
        bindingTitle: 'Bestehendes Konto verknüpfen',
        bindingHintPrefix: 'Für die E-Mail-Adresse existiert bereits ein Konto ',
        bindingHintSuffix: ". Geben Sie das Passwort dieses Kontos ein, um Ihre Google-Anmeldung zu verknüpfen.",
        enterAccountPassword: 'Kontopasswort eingeben',
        linkAccount: 'Konto verknüpfen',
        validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        validPassword: 'Passwort muss mindestens 6 Zeichen lang sein',
        validCompanyName: 'Bitte füllen Sie Ihren Firmennamen aus',
        companyNameTooLong: 'Der Firmenname darf höchstens {max} Zeichen enthalten',
        turnstileUnavailable: 'Die Sicherheitsprüfung konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
        turnstileExpired: 'Die Sicherheitsprüfung ist abgelaufen. Bitte führen Sie sie erneut durch.',
        accountDataLoadFailed: 'Das Konto wurde bestätigt, aber die Unternehmensdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.'
    },
    account: {
        title: 'Konto',
        profile: 'Profil',
        swiftAccount: 'Swift Invoice-Konto',
        connectSocial: 'Soziale Konten verbinden',
        companyLogo: 'Firmenlogo',
        logoSize: 'Logo-Größe',
        hideBusinessName: 'Firmennamen ausblenden',
        businessNameSize: 'Größe des Firmennamens',
        sizeSmall: 'Klein',
        sizeNormal: 'Normal',
        sizeBig: 'Groß',
        addLogo: 'Logo hinzufügen',
        uploading: 'wird hochgeladen...',
        currentPlan: 'Aktueller Plan: Swift {plan}',
        planActiveUntil: 'Plan aktiv bis {date}',
        sharedWithMobile: 'Mit mobiler App geteilt',
        subscriptionExpired: 'Ihr Abonnement ist abgelaufen',
        planNote: 'Melden Sie sich erneut an, wenn Ihr Abonnement-Status nicht aktualisiert wurde.',
        upgradeToPro: 'Auf Swift Pro upgraden',
        viewPlans: 'Abonnement-Pläne ansehen',
        connecting: 'Verbindung wird hergestellt…',
        connectGoogle: 'Google verbinden',
        googleConnected: 'Google verbunden',
        googleConnectedWithEmail: 'Google verbunden ({email})',
        connectApple: 'Apple verbinden',
        appleConnected: 'Apple verbunden',
        appleConnectedWithEmail: 'Apple verbunden ({email})',
        logoUuidMissing: 'UUID des Firmenlogos fehlt',
        googleConnectedToast: 'Google-Konto verbunden.',
        appleConnectedToast: 'Apple-Konto verbunden.',
        logoUploadEmpty: 'Bitte wählen Sie ein Bild aus.',
        logoUploadSize: 'Das Bild darf nicht größer als 10 MB sein.',
        logoUploadType: 'Es werden nur JPEG-, PNG- und BMP-Bilder unterstützt.',
        logoUploadFailed: 'Das Firmenlogo konnte nicht hochgeladen werden.',
        logoUnavailable: 'Die Logodatei ist nicht verfügbar. Bitte erneut hochladen.',
        deleteAccount: 'Konto löschen',
        deleteAccountDescription: 'Schließen Sie Ihr Swift Invoice-Konto dauerhaft.',
        deleteAccountTitle: 'Konto löschen?',
        deleteAccountWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
        deleteAccountConfirm: 'Geben Sie Ihr Passwort ein, um die Kontolöschung zu bestätigen.',
        deleteAccountPasswordPlaceholder: 'Passwort eingeben'
    },
    menu: {
        openNavigation: 'Navigation öffnen',
        closeNavigation: 'Navigation schließen',
        invoices: 'Rechnungen',
        estimates: 'Kostenvoranschläge',
        purchaseOrders: 'Bestellungen',
        creditMemos: 'Gutschriften',
        time: 'Zeit',
        items: 'Artikel',
        clients: 'Kunden',
        expenses: 'Ausgaben',
        reports: 'Berichte',
        settings: 'Einstellungen',
        companyInfo: 'Firmeninfo',
        taxes: 'Steuern',
        default: 'Standard',
        customizeInvoice: 'Rechnung anpassen',
        sendFeedback: 'Feedback senden',
        newReply: '1 neue Antwort',
        signOut: 'Abmelden',
        signOutConfirm: 'Möchten Sie sich wirklich abmelden?',
        addBusiness: 'Unternehmen hinzufügen',
        newBusinessTitle: 'Neues Unternehmen',
        businessName: 'Unternehmensname',
        businessNamePlaceholder: 'Unternehmensname eingeben',
        createBusiness: 'Erstellen',
        businessNameRequired: 'Unternehmensname eingeben',
        createBusinessSuccess: 'Unternehmen erstellt',
        deleteBusiness: 'Unternehmen löschen',
        deleteBusinessTitle: 'Unternehmen löschen',
        deleteBusinessConfirm: '„{name}“ löschen?',
        deleteBusinessWarning: 'Alle Daten dieses Unternehmens werden gelöscht.',
        deleteBusinessSuccess: 'Unternehmen erfolgreich gelöscht',
        trialDaysLeft: 'Noch {days} Tage Testzeit',
        upgradeAccount: 'Konto upgraden'
    },
    network: {
        loginExpired: 'Anmeldung abgelaufen, bitte melden Sie sich erneut an',
        requestTimeout: 'Zeitüberschreitung der Anfrage, bitte überprüfen Sie das Netzwerk'
    },
    language: {
        label: 'Sprache',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        listLoadFailed: 'Rechnungen konnten nicht geladen werden.',
        summaryLoadFailed: 'Rechnungssummen konnten nicht geladen werden.',
        invoiceNumberPlaceholder: 'Rechnungsnummer eingeben',
        filterAllClients: 'Alle Kunden',
        clientOptionsLoadFailed: 'Kunden für den Filter konnten nicht geladen werden.',
        filterAllStatuses: 'Alle Status',
        filterUnpaid: 'Unbezahlt',
        filterPaid: 'Bezahlt',
        filterOverdue: 'Überfällig',
        filterUnsent: 'Nicht gesendet',
        filterSent: 'Gesendet',
        filterStartDate: 'Startdatum',
        filterEndDate: 'Enddatum',
        searchPlaceholder: 'Rechnungen durchsuchen',
        addInvoice: 'Rechnung hinzufügen',
        overdueInvoices: 'Überfällige Rechnungen',
        paidInvoices: 'Bezahlte Rechnungen',
        unpaidInvoices: 'Unbezahlte Rechnungen',
        unsentInvoices: 'Nicht gesendete Rechnungen',
        columnNumber: 'Nummer',
        columnClient: 'Kunde',
        columnStatus: 'Status',
        statusFullyPaid: 'Vollständig bezahlt',
        statusPartial: 'Teilweise',
        statusOverdue: 'Überfällig',
        statusUnsent: 'Nicht gesendet',
        statusSent: 'Gesendet',
        statusOpened: 'Geöffnet',
        actionRecordPayment: 'Zahlung erfassen',
        actionMarkAsSent: 'Als gesendet markieren',
        actionCopy: 'Kopieren',
        actionDelete: 'Löschen',
        copyDialogTitle: 'Rechnung kopieren',
        copyTargetType: 'Kopieren nach',
        copyOptions: 'Kopieroptionen',
        copyClient: 'Klient kopieren',
        copyItems: 'Artikel kopieren',
        copyAttachments: 'Anhänge kopieren',
        confirmDelete: 'Dies löscht die Rechnung. Fortfahren?',
        copySuccess: 'Rechnung kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        deleteSuccess: 'Rechnung gelöscht',
        deleteFailed: 'Löschen fehlgeschlagen',
        recordPaymentDialogTitle: 'Zahlung erfassen',
        markAsFullyPaid: 'Als vollständig bezahlt markieren',
        formAmount: 'Betrag',
        formDate: 'Datum',
        formPaymentMethod: 'Zahlungsmethode',
        formNote: 'Notiz',
        allYears: 'Alle Jahre',
        errorNoOutstandingBalance: 'Kein offener Betrag ist zur Zahlung verfügbar',
        errorInvalidPaymentAmount: 'Geben Sie einen Betrag größer als null mit höchstens 5 Dezimalstellen ein',
        dueDateToday: 'Heute',
        dueDateDaysAgo: '{days} Tage her',
        dueDateInDays: 'in {days} Tagen'
    },
    estimate: {
        filterAllStatuses: 'Alle Status',
        pageTitlePurchaseOrders: 'Bestellungen',
        pageTitleEstimates: 'Kostenvoranschläge',
        pageTitleCreditMemos: 'Gutschriften',
        searchPlaceholderPurchaseOrders: 'Bestellungen durchsuchen',
        searchPlaceholderEstimates: 'Kostenvoranschläge durchsuchen',
        searchPlaceholderCreditMemos: 'Gutschriften durchsuchen',
        addPurchaseOrder: 'Bestellung hinzufügen',
        addEstimate: 'Kostenvoranschlag hinzufügen',
        addCreditMemo: 'Gutschrift hinzufügen',
        columnNumber: 'Nummer',
        columnClient: 'Kunde',
        columnDate: 'Datum',
        columnEmail: 'E-Mail',
        columnStatus: 'Status',
        columnTotal: 'Gesamt',
        statusUnsent: 'Nicht gesendet',
        statusSent: 'Gesendet',
        actionMarkAsSent: 'Als gesendet markieren',
        actionCopy: 'Kopieren',
        actionDelete: 'Löschen',
        actionConvertToInvoice: 'In Rechnung umwandeln',
        copyDialogTitle: '{document} kopieren',
        copyTargetType: 'Kopieren nach',
        copyOptions: 'Kopieroptionen',
        copyClient: 'Klient kopieren',
        copyItems: 'Artikel kopieren',
        copyAttachments: 'Anhänge kopieren',
        confirmDelete: 'Dies löscht {document}. Fortfahren?',
        convertConfirm: 'Dieses {document} in eine Rechnung umwandeln? Das Datum wird auf heute gesetzt.',
        copySuccess: '{document} kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        convertSuccess: '{document} in Rechnung umgewandelt',
        convertFailed: 'Umwandlung fehlgeschlagen',
        deleteSuccess: '{document} gelöscht',
        deleteFailed: 'Löschen fehlgeschlagen',
        dueDateToday: 'Heute',
        dueDateDaysAgo: '{days} Tage her',
        dueDateInDays: 'in {days} Tagen'
    },
    item: {
        pageTitle: 'Artikel',
        searchPlaceholder: 'Artikel durchsuchen',
        addItem: 'Artikel hinzufügen',
        columnInventoryCountUnit: 'Lagerbestand/Einheit',
        noDescription: 'Keine Artikelbeschreibung'
    },
    client: {
        detailsTitle: 'Kundendetails',
        contactDetails: 'Kontaktdaten',
        invoiceHistory: 'Rechnungsverlauf',
        noInvoices: 'Noch keine Rechnungen',
        retry: 'Erneut versuchen',
        detailsLoadFailed: 'Kundendetails konnten nicht geladen werden.',
        invoicesLoadFailed: 'Rechnungen konnten nicht geladen werden.',
        deleteConfirm: 'Diesen Kunden löschen?',
        deleted: 'Kunde gelöscht',
        pageTitle: 'Kunden',
        searchPlaceholder: 'Kunden durchsuchen',
        addClient: 'Kunden hinzufügen',
        columnClientName: 'Kundenname',
        columnEmail: 'E-Mail',
        columnPhone: 'Telefon',
        columnBalanceDue: 'Offener Betrag',
        noNameFallback: 'KEIN NAME'
    },
    expense: {
        pageTitle: 'Ausgaben',
        searchPlaceholder: 'Ausgaben durchsuchen',
        allCategories: 'Alle Kategorien',
        noCategory: 'Keine Kategorie',
        categoryLoadFailed: 'Ausgabenkategorien konnten nicht geladen werden.',
        addExpense: 'Ausgabe hinzufügen',
        columnDescription: 'Beschreibung',
        columnDate: 'Datum',
        columnTotal: 'Gesamt',
        tip: 'Trinkgeld'
    },
    report: {
        headerTitle: 'Berichte',
        tabDashboard: 'Dashboard',
        tabReportList: 'Berichtsliste',
        export: 'Exportieren',
        annualSalesByClient: 'Jährliche Verkäufe nach Kunde',
        otherClients: 'Andere Kunden',
        totalOutstandingBalance: 'Gesamter offener Betrag',
        invoicesCountSuffix: 'Rechnungen',
        byMonth: 'Nach Monat',
        byQuarter: 'Nach Quartal',
        noSalesFound: 'Keine Verkäufe gefunden',
        filterReportTypes: 'Berichtstypen',
        filterTimePeriod: 'Zeitraum',
        filterView: 'Ansicht',
        filterTaxYear: 'Steuerjahr',
        filterQuarter: 'Quartal',
        filterMonth: 'Monat',
        filterStartDate: 'Startdatum',
        filterEndDate: 'Enddatum',
        invalidCustomDateRange: 'Das Startdatum darf nicht nach dem Enddatum liegen',
        searchClientName: 'Kundennamen suchen',
        searchItemName: 'Artikelnamen suchen',
        searchSalesJournal: 'Rechnungsnummer oder Kundenname suchen',
        searchPaymentsJournal: 'Rechnungsnummer, Kundenname oder Zahlungsart suchen',
        periodMonth: 'Monat',
        periodQuarter: 'Quartal',
        periodYear: 'Jahr',
        periodAllTaxYears: 'Alle Steuerjahre',
        periodCustom: 'Benutzerdefiniert',
        taxYearLabel: 'Steuerjahr {year}',
        quarterLabel: 'Q{quarter} Steuerjahr {year}',
        optionMonthly: 'Monatlich',
        optionQuarterly: 'Quartalsweise',
        customerAgingTitle: 'Forderungsalter',
        noDataForDateRange: 'Keine Daten für diesen Zeitraum',
        typeSalesByDate: 'Verkäufe nach Datum',
        typeSalesByClient: 'Verkäufe nach Kunde',
        typeSalesByItem: 'Verkäufe nach Artikel',
        typeSalesJournal: 'Verkaufsjournal',
        typePaymentsByDate: 'Zahlungen nach Datum',
        typePaymentsByClient: 'Zahlungen nach Kunde',
        typePaymentsByType: 'Zahlungen nach Typ',
        typePaymentsJournal: 'Zahlungsjournal',
        typeExpenseByCategory: 'Ausgaben nach Kategorie',
        typeExpenseJournal: 'Ausgabenjournal',
        typeProfitLoss: 'Gewinn und Verlust',
        typeTaxes: 'Steuern',
        typeCustomerAging: 'Forderungsalter',
        allYears: 'Alle Jahre',
        allTime: 'Gesamter Zeitraum',
        allSales: 'Alle Verkäufe',
        taxYearSales: 'Verkäufe Steuerjahr {year}',
        firstColumnMonth: 'Monat',
        firstColumnQuarter: 'Quartal',
        firstColumnYear: 'Jahr',
        firstColumnDay: 'Tag',
        firstColumnDate: 'Datum',
        columnSubTotal: 'Zwischensumme',
        columnTax: 'Steuer',
        columnDiscount: 'Rabatt',
        columnTotal: 'Gesamt',
        columnAmountPaid: 'Bezahlter Betrag',
        columnAmountOwed: 'Geschuldeter Betrag',
        columnClient: 'Kunde',
        columnItem: 'Artikel',
        columnUnitType: 'Einheitentyp',
        columnQuantity: 'Menge',
        columnRateAvg: 'Satz (Ø)',
        columnInvoiceDate: 'Rechnungsdatum',
        columnInvoiceNo: 'Rechnungs-Nr.',
        columnType: 'Typ',
        columnPaymentDate: 'Zahlungsdatum',
        columnCategory: 'Kategorie',
        columnExpenseDate: 'Ausgabedatum',
        columnMerchant: 'Händler',
        columnDescription: 'Beschreibung',
        columnCurrentDue: 'Aktuell offen',
        column1To30DaysOverdue: '1-30 Tage überfällig',
        column31To60DaysOverdue: '31-60 Tage überfällig',
        column61To90DaysOverdue: '61-90 Tage überfällig',
        column91PlusDaysOverdue: '91+ Tage überfällig',
        columnSection: 'Bereich',
        columnAmount: 'Betrag',
        columnPreTaxSales: 'Umsatz vor Steuern',
        columnTaxLabel: 'Steuerbezeichnung',
        columnTaxRate: 'Steuersatz',
        columnTotalTax: 'Gesamtsteuer',
        columnPostTaxTotal: 'Gesamt nach Steuern',
        profitLossTitle: 'Gewinn und Verlust',
        taxesTitle: 'Steuern',
        profitLossRevenue: 'Einnahmen',
        profitLossExpense: 'Ausgaben',
        profitLossProfit: 'Gewinn',
        profitLossCash: 'Kasse',
        profitLossAccrued: 'Periodengerecht',
        profitLossAccountsReceivables: 'Forderungen',
        profitLossNone: '[Keine]',
        profitLossTotalExpenses: 'Gesamtausgaben',
        profitLossCashProfit: 'Bargewinn',
        profitLossAccruedProfit: 'Periodengerechter Gewinn',
        monthNames: 'Jan, Feb, Mär, Apr, Mai, Jun, Jul, Aug, Sep, Okt, Nov, Dez',
        totalRowLabel: 'Gesamt'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Hinzufügen',
        initialDataLoadFailed: 'Dokumenteinstellungen konnten nicht geladen werden. Bearbeiten und Speichern sind deaktiviert.',
        searchSuggestionsLoadFailed: 'Suchvorschläge konnten nicht geladen werden.',
        invoicePrefix: 'Rechnungspräfix',
        tabCreate: 'Erstellen',
        tabPreview: 'Vorschau',
        tabSendEmail: 'E-Mail senden',
        sectionClient: 'Kunde',
        addClient: 'Kunden hinzufügen',
        dialogClientInfo: 'Kundeninformationen',
        basicInformation: 'Grundinformationen',
        labelName: 'Name',
        labelEmail: 'E-Mail',
        labelPhone: 'Telefon',
        billingAddress: 'Rechnungsadresse',
        labelLine1: 'Zeile 1',
        labelLine2: 'Zeile 2',
        labelLine3: 'Zeile 3',
        shippingAddress: 'Lieferadresse',
        labelShippingName: 'Liefername',
        labelNotes: 'Notizen',
        placeholderCreateOrSelect: 'Erstellen oder auswählen...',
        placeholderClientNotes: "Notizen zum Kunden hinzufügen. Diese kann der Kunde nicht sehen",
        sectionItems: 'Artikel',
        saveToYourItem: 'In Ihrem Artikel speichern',
        stock: 'Bestand:',
        placeholderItemCode: 'Artikelcode',
        placeholderQuantity: 'Menge',
        placeholderRate: 'Satz',
        placeholderInputDescription: 'Beschreibung eingeben',
        placeholderInputComment: 'Kommentar eingeben',
        placeholderAddRecipient: 'Empfänger hinzufügen',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'E-Mail-Betreff',
        placeholderMessage: 'Schreiben Sie Ihre Nachricht...',
        labelTo: 'An',
        labelSubject: 'Betreff',
        sectionAttachments: 'Anhänge',
        sectionComment: 'Kommentar',
        addItem: 'Artikel hinzufügen',
        addPhoto: 'Foto hinzufügen',
        addPayment: 'Zahlung hinzufügen',
        goBack: 'zurück',
        dialogShippingInfo: 'Versandinformationen',
        dialogRecordPayment: 'Zahlung erfassen',
        dialogJobDetails: 'Auftragsdetails',
        labelAmount: 'Betrag',
        labelShipDate: 'Versanddatum',
        labelShipVia: 'Versand über',
        labelTrackingNumber: 'Sendungsverfolgungsnummer',
        labelFob: 'FOB',
        columnDate: 'Datum',
        columnType: 'Typ',
        msgClientEmailError: 'Kunden-E-Mail-Fehler',
        msgAmountGreaterThanZero: 'Der Betrag muss größer als null sein',
        msgInvalidAmount: 'Der Betrag muss zwischen 0 und 999.999.999.999.999 liegen und darf höchstens 5 Dezimalstellen haben',
        calculatedAmountOutOfRange: 'Der berechnete Betrag überschreitet den unterstützten Bereich',
        msgTextTooLong: '{field} darf höchstens {max} Zeichen enthalten',
        msgTextTooLongBytes: '{field} darf höchstens {max} UTF-8-Bytes enthalten',
        msgInvalidJobDetails: 'Die Auftragsdetails enthalten ungültige Daten',
        msgMorePaymentThanBalance: 'Mehr Zahlung als offener Betrag',
        mailSentSuccessfully: 'E-Mail erfolgreich gesendet',
        cumulativeTaxNotice: 'Das Web unterstützt die Kumulierung von Steuern in der Rechnung nicht...',
        confirmUnsavedChanges: 'Sie haben ungespeicherte Änderungen. Möchten Sie diese speichern oder verwerfen?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Steuer, Rabatt und Quellensteuer',
        purchaseOrder: 'Bestellung',
        placeholderPurchaseOrderPrefix: 'Bestellungspräfix',
        placeholderCreditMemoPrefix: 'Gutschriftpräfix',
        placeholderEstimatePrefix: 'Kostenvoranschlagspräfix',
        labelStatus: 'Status',
        statusIssued: 'Ausgestellt',
        statusApproved: 'Genehmigt',
        statusPending: 'Ausstehend',
        statusWithdrawn: 'Zurückgezogen',
        tax: 'Steuer'
    },
    createEstimate: {
        pageTitlePrefix: 'Hinzufügen',
        cumulativeTaxNotice: 'Das Web unterstützt die Kumulierung von Steuern im Kostenvoranschlag nicht...'
    },
    updateInvoice: {
        pageTitlePrefix: 'Aktualisieren',
        deletePrefix: 'Löschen',
        confirmDelete: 'Dadurch wird die Rechnung gelöscht. Fortfahren?',
        cumulativeTaxNotice: 'Diese Rechnung enthält kumulierte Steuern. Das Web unterstützt diese Funktion vorerst nicht'
    },
    updateEstimate: {
        pageTitlePrefix: 'Aktualisieren',
        deletePrefix: 'Löschen',
        confirmDelete: 'Dadurch wird {document} gelöscht. Fortfahren?',
        cumulativeTaxNotice: 'Dieser Kostenvoranschlag enthält kumulierte Steuern. Das Web unterstützt diese Funktion vorerst nicht'
    },
    createAccount: {
        title: 'Konto erstellen',
        placeholderEmail: 'E-Mail',
        placeholderPassword: 'Passwort',
        placeholderCompanyName: 'Firmenname',
        createAccountButton: 'Konto erstellen',
        alreadyHaveAccount: 'Bereits ein Konto?',
        signIn: 'Anmelden',
        validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        validPassword: 'Passwort muss mindestens 6 Zeichen lang sein',
        validCompanyName: 'Bitte füllen Sie Ihren Firmennamen aus',
        companyNameTooLong: 'Der Firmenname darf höchstens {max} Zeichen enthalten'
    },
    clientCreate: {
        pageTitle: 'Kunden hinzufügen',
        basicInformation: 'Grundinformationen',
        labelName: 'Name',
        placeholderName: 'Namen eingeben...',
        labelEmail: 'E-Mail',
        placeholderEmail: 'E-Mail-Adresse eingeben...',
        labelPhone: 'Telefon',
        placeholderPhone: 'Telefonnummer eingeben...',
        billingAddress: 'Rechnungsadresse',
        labelLine1: 'Zeile 1',
        labelLine2: 'Zeile 2',
        labelLine3: 'Zeile 3',
        shippingAddress: 'Lieferadresse',
        sameAsBilling: 'Wie Rechnungsadresse',
        labelShippingName: 'Liefername',
        labelShippingLine1: 'Zeile 1',
        labelShippingLine2: 'Zeile 2',
        labelShippingLine3: 'Zeile 3',
        labelNotes: 'Notizen',
        placeholderNotes: "Notizen zum Kunden hinzufügen. Diese kann der Kunde nicht sehen",
        defaultDiscount: 'Standardrabatt',
        validDefaultDiscount: 'Bitte geben Sie einen gültigen Standardrabatt ein',
        validName: 'Bitte geben Sie einen Kundennamen ein',
        validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
    },
    clientUpdate: {
        pageTitle: 'Kunden aktualisieren',
        confirmDelete: 'Dadurch wird der Kunde gelöscht. Fortfahren?'
    },
    itemCreate: {
        pageTitle: 'Artikel hinzufügen',
        itemTitle: 'Artikel',
        labelCost: 'Kosten',
        rateSign: 'Vorzeichen des Preises',
        inventorySign: 'Vorzeichen der Bestandsanpassung',
        labelUnit: 'Einheit',
        placeholderUnit: 'Einheit',
        defaultTaxes: 'Standardsteuern',
        taxOff: 'aus',
        inventoryTitle: 'Lagerbestand',
        currentInventory: 'Aktueller Lagerbestand',
        adjustInventory: 'Lagerbestand anpassen',
        increase: 'Erhöhen',
        decrease: 'Verringern',
        placeholderQuantity: 'Menge',
        placeholderDateAndTime: 'Datum und Uhrzeit',
        placeholderNote: 'Notiz',
        addButton: 'Hinzufügen',
        columnDate: 'Datum',
        columnQuantity: 'Menge',
        columnNote: 'Notiz',
        withholdingTitle: 'Quellensteuer',
        msgInventoryCannotDisable: 'Lagerbestand kann nach der Aktivierung nicht deaktiviert werden',
        msgDescriptionRequired: 'Die Artikelbeschreibung ist erforderlich',
        msgInvalidRate: 'Der Preis muss zwischen -999.999.999.999.999 und 999.999.999.999.999 liegen und darf höchstens 4 Dezimalstellen haben',
        msgInvalidCost: 'Die Kosten müssen zwischen 0 und 999.999.999.999.999 liegen und dürfen höchstens 5 Dezimalstellen haben',
        msgInvalidInventory: 'Die Menge muss zwischen 0 und 999.999.999.999.999 liegen und darf höchstens 5 Dezimalstellen haben',
        msgInvalidUnit: 'Die Einheit darf weder && enthalten noch länger als 255 Zeichen sein',
        msgQuantityRequired: 'Menge ist erforderlich',
        msgDateRequired: 'Datum und Uhrzeit sind erforderlich'
    },
    itemUpdate: {
        pageTitle: 'Artikel bearbeiten',
        columnInvoice: 'Rechnung',
        confirmDelete: 'Dadurch wird der Artikel gelöscht. Fortfahren?'
    },
    createStatement: {
        pageTitle: 'Auszug',
        tabPreview: 'Vorschau',
        tabSendEmail: 'E-Mail senden',
        createAction: 'Auszug erstellen',
        from: 'Von',
        to: 'Bis',
        invoices: 'Rechnungen',
        balanceDue: 'Offener Betrag',
        editTitle: 'Auszug bearbeiten',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        onlyShowUnpaid: 'Nur unbezahlte Rechnungen anzeigen',
        unpaidOnlyActive: 'Dieser Auszug enthält nur unbezahlte Rechnungen.',
        dateRequired: 'Start- und Enddatum sind erforderlich',
        invalidDateRange: 'Das Enddatum darf nicht vor dem Startdatum liegen'
    },
    time: {
        pageTitle: 'Zeit',
        unbilled: 'Nicht abgerechnet',
        billed: 'Abgerechnet',
        searchPlaceholder: 'Zeit nach Kunde oder Beschreibung suchen',
        addTime: 'Zeit hinzufügen',
        noTime: 'Keine Zeiteinträge',
        noTimeDescription: 'Erstellen Sie einen Zeiteintrag für abrechenbare Arbeit.',
        noClient: 'Kein Kunde',
        filterAndSort: 'Filtern und sortieren',
        year: 'Jahr',
        groupBy: 'Gruppieren nach',
        sortBy: 'Sortieren nach',
        order: 'Reihenfolge',
        yearly: 'Jährlich',
        quarterly: 'Vierteljährlich',
        monthly: 'Monatlich',
        ascending: 'Aufsteigend',
        descending: 'Absteigend',
        duration: 'Dauer',
        createTitle: 'Zeit erfassen',
        editTitle: 'Zeit',
        selectClient: 'Kunden auswählen',
        start: 'Start',
        end: 'Ende',
        hours: 'Stunden',
        minutes: 'Minuten',
        ratePreset: 'Stundensatz',
        customRate: 'Benutzerdefinierter Satz',
        rateName: 'Name des Stundensatzes',
        showRateName: 'Name des Stundensatzes auf der Rechnung anzeigen',
        invalidDate: 'Start- und Endzeit sind erforderlich',
        endBeforeStart: 'Die Endzeit darf nicht vor der Startzeit liegen',
        invalidDuration: 'Die Dauer muss mit Start- und Endzeit übereinstimmen',
        invalidRate: 'Der Stundensatz muss zwischen 0 und 999999999999999 liegen und darf höchstens 5 Dezimalstellen haben',
        rateNameTooLong: 'Der Name des Stundensatzes darf höchstens 255 Zeichen lang sein',
        descriptionTooLong: 'Die Beschreibung darf höchstens 3000 Zeichen lang sein',
        confirmDelete: 'Dieser Zeiteintrag wird gelöscht. Fortfahren?'
    },
    setting: {
        taxInfo: 'Steuerinfo',
        taxes: 'Steuern',
        taxYearStarts: 'Steuerjahr beginnt',
        taxYearStartSubtitle: 'Legen Sie den ersten Tag des Geschäftsjahres fest',
        rateLabel: 'Satz(%)',
        abbreviation: 'Abkürzung',
        addTax: 'Steuer hinzufügen',
        month: 'Monat',
        day: 'Tag',
        monthPlaceholder: 'Monat',
        dayPlaceholder: 'Tag',
        saveTaxYearStart: 'Speichern',
        deleteDialogTitle: 'Löschen',
        confirmDeleteTax: 'Möchten Sie diese Steuer wirklich löschen?',
        deleteConfirm: 'Löschen',
        taxInfoDialogTitle: 'Steuerinfo',
        taxName: 'Steuername',
        standardRate: 'Standardsteuersatz (%)',
        additionalRate: 'Zusatzsatz',
        deleteRateX: 'X',
        addRate: 'Satz hinzufügen',
        taxType: 'Steuerart',
        exclusive: 'Exklusiv',
        inclusive: 'Inklusiv',
        close: 'schließen',
        saveTax: 'Steuer speichern',
        cantOpenDetailMessage: 'Diese Steuer enthält kumulierte Steuern. Das Web unterstützt diese Funktion vorerst nicht',
        closeButton: 'Schließen',
        rateIsRequired: 'Satz ist erforderlich',
        rateIsRequiredMsg: 'Satz ist erforderlich',
        monthAndDayRequired: 'Monat und Tag sind erforderlich',
        additionalRateNumber: 'Zusätzlicher Satz {number} (%)',
        taxNameRequired: 'Steuername ist erforderlich',
        invalidTaxRate: 'Der Steuersatz muss zwischen 0 und 999999999999999 liegen und darf höchstens 4 Dezimalstellen haben',
        duplicateTaxRate: 'Steuersätze müssen eindeutig sein',
        taxRatesTooLong: 'Es gibt zu viele Steuersätze zum Speichern',
        withholdingNameRequired: 'Die Abkürzung ist erforderlich, wenn die Quellensteuer aktiv ist',
        moreRate: ' weiterer Satz',
        moreRates: ' weitere Sätze'
    },
    companyInfo: {
        title: 'Firmeninfo',
        details: 'Details',
        businessName: 'Firmenname',
        businessNamePlaceholder: 'Firmenname',
        name: 'Name',
        phone: 'Telefon',
        email: 'E-Mail',
        businessNumber: 'Geschäftsnummer',
        taxNo: 'Steuer N°',
        deleteField: 'löschen',
        addNewField: 'Neues Feld hinzufügen',
        address: 'Adresse',
        line1: 'Zeile 1',
        line2: 'Zeile 2',
        line3: 'Zeile 3',
        currency: 'Währung',
        currencyLabel: 'Währung',
        symbol: 'Symbol',
        placement: 'Platzierung',
        before: 'Vor',
        after: 'Nach',
        thousandSymbol: 'Tausendertrennzeichen',
        decimalSymbol: 'Dezimaltrennzeichen',
        decimalPlaces: 'Dezimalstellen',
        example: 'Beispiel',
        terms: 'Zahlungsbedingungen',
        termsLabel: 'Zahlungsbedingungen',
        termSameDay: 'Gleicher Tag',
        term7Days: '7 Tage',
        term14Days: '14 Tage',
        term21Days: '21 Tage',
        term30Days: '30 Tage',
        term45Days: '45 Tage',
        term60Days: '60 Tage',
        term90Days: '90 Tage',
        term180Days: '180 Tage',
        term365Days: '365 Tage',
        paymentInfo: 'Zahlungsinformationen',
        displayOnInvoices: 'Auf Rechnungen anzeigen',
        titlePlaceholder: 'Titel',
        jobDetails: 'Auftragsdetails',
        deleteJobDetail: 'löschen',
        addNewJobField: 'neues Feld hinzufügen',
        fieldNameRequired: '{field}: Feldname ist erforderlich',
        reservedCharacters: '{field}: Feldnamen dürfen weder : noch && enthalten; Werte dürfen kein && enthalten',
        serializedDataTooLong: '{field}-Daten überschreiten das Datenbanklimit',
        textDataTooLong: '{field} überschreitet das Datenbanklimit'
    },
    default: {
        title: 'Standard',
        emailMessage: 'E-Mail-Nachricht',
        enterDescription: 'Beschreibung eingeben',
        emailCc: 'E-Mail-Cc',
        emailBcc: 'E-Mail-Bcc',
        emailTip: 'Gleichzeitig eine E-Mail an die obige Adresse senden.',
        defaultComments: 'Standardkommentare',
        invoice: 'Rechnung',
        estimate: 'Kostenvoranschlag',
        purchaseOrder: 'Bestellung',
        creditMemo: 'Gutschrift',
        emailValidError: 'E-Mail gültig'
    },
    invoiceDesign: {
        template: 'Vorlage',
        color: 'Farbe',
        labels: 'Beschriftungen',
        labelInvoice: 'Rechnung',
        labelEstimate: 'Kostenvoranschlag',
        labelPurchaseOrder: 'Bestellung',
        labelCreditMemo: 'Gutschrift',
        labelReceipt: 'BELEG',
        labelTermsFormat: 'Format der Bedingungen',
        labelBillTo: 'Rechnung an',
        labelFor: 'Für',
        labelDate: 'Datum',
        labelInvoiceNo: 'Rechnungs-Nr.',
        labelEstimateNo: 'Kostenvoranschlags-Nr.',
        labelPoNo: 'Bestell-Nr.',
        labelCreditMemoNo: 'Gutschrift-Nr.',
        labelDueDate: 'Fälligkeitsdatum',
        labelTerms: 'Zahlungsbedingungen',
        labelAmount: 'Betrag',
        labelCode: 'Code',
        labelDescription: 'Beschreibung',
        labelQuantity: 'Menge',
        labelRate: 'Satz',
        labelTax: 'Steuer',
        labelSubtotal: 'Zwischensumme',
        labelBalanceDue: 'Offener Betrag',
        labelDiscount: 'Rabatt',
        labelNonTaxableItem: 'Nicht steuerpflichtiger Artikel',
        labelPaid: 'Bezahlt',
        labelShipping: 'Versand',
        labelTotal: 'Gesamt',
        labelIncludes: 'Enthält',
        labelTotalAmountPaid: 'Gesamt bezahlter Betrag',
        labelShipDate: 'Versanddatum',
        labelShipTo: 'Liefern an',
        labelShipVia: 'Versand über',
        labelTrackingNo: 'Sendungsverfolgungs-Nr.',
        labelFob: 'F.O.B',
        prefix: 'Präfix',
        prefixInvoice: 'Rechnung',
        prefixEstimate: 'Kostenvoranschlag',
        prefixPurchaseOrder: 'Bestellung',
        prefixCreditMemo: 'Gutschrift',
        nextNumber: 'Nächste Nummer',
        numberingBeginsAt: 'Nummerierung beginnt bei',
        nextNumberInvoice: 'Rechnung',
        nextNumberEstimate: 'Kostenvoranschlag',
        nextNumberPurchaseOrder: 'Bestellung',
        nextNumberCreditMemo: 'Gutschrift',
        options: 'Optionen',
        optionTerms: 'Zahlungsbedingungen',
        optionDueDate: 'Fälligkeitsdatum',
        optionShippingAddress: 'Lieferadresse',
        optionProductCode: 'Produktcode',
        optionQuantityAndRate: 'Menge und Satz',
        optionUnit: 'Einheit',
        optionTax: 'Steuer',
        optionAmount: 'Betrag',
        optionNonTaxableItemStar: 'Stern für nicht steuerpflichtigen Artikel',
        optionDiscount: 'Rabatt anzeigen',
        optionTaxBreakdown: 'Steueraufschlüsselung',
        optionPaymentHistory: 'Zahlungsverlauf',
        optionStamp: 'Stempel',
        optionPageNumber: 'Seitenzahl',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "Danke für Ihr Geschäft! Wir hoffen, Sie sind mit unserer Arbeit zufrieden. Bitte überweisen Sie die Zahlung innerhalb von 15 Tagen. Fragen? Kommentare? Kontaktieren Sie uns unter (111)111-1234 oder schreiben Sie uns an example@owner.com, wir beantworten gerne alle Fragen oder Anliegen.",
        previewSubtotal: 'Zwischensumme',
        previewVat: 'MwSt 17.00%',
        previewPayment1: 'Zahlung am Oct 1, 2019',
        previewPayment2: 'Zahlung am Oct 2, 2019',
        invalidNextNumber: 'Jede nächste Nummer muss eine ganze Zahl zwischen 0 und {max} sein'
    },
    feedback: {
        title: 'Feedback senden',
        invalidEmailNoticePrefix: 'Die E-Mail-Adresse Ihres Kontos ist ungültig, daher konnten wir Sie nicht kontaktieren. Bitte senden Sie Ihr Feedback von einer gültigen E-Mail-Adresse an',
        invalidEmailNoticeSuffix: 'Falls möglich, fügen Sie einen Screenshot des Problems bei; das wird uns bei der Untersuchung und Lösung helfen.',
        replyTip: 'Überprüfen Sie nach dem Senden Ihre E-Mail auf die Antwort.',
        contextTip: 'Die folgenden Konto- und Browserdaten werden mit Ihrem Feedback gesendet:',
        content: 'Inhalt',
        enterDescription: 'Beschreibung eingeben',
        contentTooLong: 'Der Inhalt darf höchstens {max} Zeichen enthalten'
    },
    createExpense: {
        title: 'Ausgabe hinzufügen',
        description: 'Beschreibung',
        expenseDescriptionPlaceholder: 'Ausgabenbeschreibung',
        total: 'Gesamt',
        tax: 'Steuer',
        tip: 'Trinkgeld',
        expenseDate: 'Ausgabedatum',
        merchant: 'Händler',
        merchantPlaceholder: 'Händlernamen eingeben',
        categoryPlaceholder: 'Kategorie auswählen',
        addNewCategory: 'Neue Kategorie hinzufügen',
        deletePhoto: 'Löschen',
        addPhoto: 'Foto hinzufügen',
        deleteCategory: 'löschen',
        addCategory: 'Kategorie hinzufügen',
        descriptionTooLong: 'Die Beschreibung darf höchstens 3.000 Zeichen lang sein.',
        merchantTooLong: 'Der Händlername darf höchstens 255 Zeichen lang sein.',
        amountInvalid: 'Gesamtbetrag, Steuer und Trinkgeld müssen jeweils zwischen 0 und 999999999999999 liegen und dürfen höchstens 5 Dezimalstellen haben.',
        categoryRequired: 'Der Kategoriename ist erforderlich.',
        categoryTooLong: 'Der Kategoriename darf höchstens 255 Zeichen lang sein.',
        photoUploadFailed: 'Das Foto konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.'
    },
    updateExpense: {
        title: 'Ausgabe aktualisieren',
        deleteExpense: 'Ausgabe löschen',
        confirmDeleteMsg: 'Dadurch wird die Ausgabe gelöscht. Fortfahren?'
    },
    notFound: {
        oops: 'HOPPLA!',
        notFoundMsg: "Wir können die gesuchte Seite leider nicht finden.",
        takeMeHome: 'Zurück zur Startseite'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Kostenloser Versand',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Computer',
        previewItem2: 'Telefon',
        previewItem3: 'Geburtstagskuchen',
        previewTaxRate: '17%',
        nonTaxableNote: '* Kennzeichnet nicht steuerpflichtigen Artikel',
        thanksMessage: "Danke für Ihr Geschäft! Wir hoffen, Sie sind mit unserer Arbeit zufrieden. Bitte überweisen Sie die Zahlung innerhalb von 15 Tagen. Fragen? Kommentare? Kontaktieren Sie uns unter (111)111-1234 oder schreiben Sie uns an example@owner.com, wir beantworten gerne alle Fragen oder Anliegen.",
        subtotal: 'Zwischensumme',
        vat: 'MwSt 17.00%',
        payment1: 'Zahlung am Oct 1, 2019',
        payment2: 'Zahlung am Oct 2, 2019',
        balanceDue: 'Offener Betrag'
    }
};
